import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import carroIcono from "../../assets/img/icono-carro2.png";
import motoIcono from "../../assets/img/moto2.png";
import React, { useState, useEffect } from "react";
import { Spinner } from "../Spinner";
import { SinUnidadAdd } from "../customFunctionalComponents/components/SinUnidadAdd";
import { useUnidades } from "../../hooks/test/useUnidades";
import Swal from "sweetalert2";
import { RegistrarEditarEventoRobo } from "../customComponents/Modals/RegistrarEditarEventoRobo";
import Paginacion from "../customComponents/Paginacion";
import { TituloUnidadesConteo } from "../customFunctionalComponents/components/TituloUnidadesConteo";

export const BuscarUnidad = ({ unidades = [], paginacion, tipoUnidades }) => {

  const [paginado, setPaginado] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [vehiculos, setVehiculos] = useState(null);
  const [actiModal, setActiModal] = useState(false);
  const [event, setEvent] = useState(false);
  const [idUnidad, setIdUnidad] = useState();
  const [viajeId, setViajeId] = useState();
  const { getUnidadesTipo, getVehiculoSearch } = useUnidades();

  // Efecto para actualizar el paginado cuando cambie la paginacion
  useEffect(() => {
    if (paginacion) {
      setPaginado({
        page: paginacion.pagina,
        limit: paginacion.totalRegistros,
        previousPage: paginacion.previousPage,
        nextPage: paginacion.nextPage,
        total: paginacion.totalRegistros,
        totalPaginas: paginacion.totalPaginas,
      });
    }
  }, [paginacion]);

  const handleAction = async (e, msg) => {
    e.preventDefault();
    await reloatUnits();
    setSearch("");
    return Swal.fire({
      title: "UNIDAD",
      text: msg,
      showConfirmButton: false,
      icon: "success",
      timer: 3000,
    });
  };

  const reloatUnits = async () => {
    setLoading(true);
    const resp = await getUnidadesTipo(
      tipoUnidades,
      paginado.page,
      paginado.limit
    );
    if (resp.ok) setVehiculos(resp.vehiculos);
    setLoading(false);
  };

  const modalClose = () => {
    setActiModal(false);
    reloatUnits();
  };

  const handleChangeSearch = async (e) => {
    const newSearchValue = e.target.value;
    setSearch(newSearchValue);

    try {
      const resp = await getVehiculoSearch(newSearchValue, tipoUnidades, 1, 5);
      if (resp.ok) {
        setVehiculos(resp.vehiculos);
        setPaginado({
          page: resp.paginacion.pagina || 1,
          limit: resp.paginacion.totalRegistros || 5,
          previousPage: resp.paginacion.previousPage || null,
          nextPage: resp.paginacion.nextPage || null,
          total: resp.paginacion.totalRegistros || 0,
          totalPaginas: resp.paginacion.totalPaginas || 1,
        });
      } else {
        // Fallback: Obtener todas las unidades si no hay resultados de búsqueda
        const fallbackResp = await getUnidadesTipo(tipoUnidades, 1, 5);
        if (fallbackResp.ok) {
          setVehiculos(fallbackResp.vehiculos);
          setPaginado({
            page: fallbackResp.paginacion.pagina || 1,
            limit: fallbackResp.paginacion.totalRegistros || 5,
            previousPage: fallbackResp.paginacion.previousPage || null,
            nextPage: fallbackResp.paginacion.nextPage || null,
            total: fallbackResp.paginacion.totalRegistros || 0,
            totalPaginas: fallbackResp.paginacion.totalPaginas || 1,
          });
        }
      }
    } catch (error) {
      console.error("Error al realizar la búsqueda:", error);
    }
  };

  let results =
    !search && vehiculos === null
      ? unidades
      : vehiculos !== null
      ? vehiculos.filter((elemento) =>
          elemento.unidad_vin
            .toString()
            .toLowerCase()
            .includes(search.toLowerCase())
        )
      : unidades.filter((elemento) =>
          elemento.unidad_vin
            .toString()
            .toLowerCase()
            .includes(search.toLowerCase())
        );

  // Manejar el cambio de página
  const handlePageChange = async (newPage) => {
    const resp = await getUnidadesTipo(tipoUnidades, newPage, 5);
    if (resp.ok) {
      setVehiculos(resp.vehiculos);
      setPaginado((prev) => ({
        ...prev,
        page: newPage,
        previousPage: newPage > 1 ? newPage - 1 : null,
        nextPage: newPage < prev.totalPaginas ? newPage + 1 : null,
      }));
    }
  };
  return (
    <>
      {loading && <Spinner />}
      <div className="row justify-content-center">
        <div className="col-4 mt-4 inputWithIcon">
          <input
            className="form-control selectCedis mb-4"
            placeholder="BUSCAR UNIDAD"
            name="palabra"
            value={search}
            onChange={handleChangeSearch}
          ></input>
          <button style={{ padding: "10px" }}>
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </button>
          {results.length > 0 && <TituloUnidadesConteo longitud={paginado.total}></TituloUnidadesConteo>}
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          {results.map((x) => {
            return (
              <>
                <div
                  className="row unidad-element cursor animated delay-01s my-3"
                  key={x.unidad_id}
                  onClick={() => {
                    setActiModal(true);
                    setIdUnidad(x.unidad_id);
                    if (x.unidad_disponible) {
                      setEvent("REGISTRAR");
                    } else if (!x.unidad_disponible) {
                      setEvent("EDITAR");
                      if (x.evento_seguridad)
                        setViajeId(x.registro_seguridad.evento_seguridad_id);
                    }
                  }}
                >
                  <div
                    className="col-md-2 text-center pb-3 bordersLeftRounded"
                    style={{ background: "rgb(245, 245, 245)" }}
                  >
                    <div className="contenedorCarro-salida pt-3">
                      <img
                        src={tipoUnidades === 4 ? carroIcono : motoIcono}
                        alt="imagen"
                        className="img-fluid"
                        style={{ inlineSize: "55px", maxWidth: "45%" }}
                      />
                    </div>
                  </div>
                  <div className="col-11 col-sm-9" style={{ margin: "auto" }}>
                    <div className="row">
                      <div className="col-9">
                        <h6>
                          <small>UNIDAD VIN: </small>
                          <b>{x.unidad_vin} </b>
                        </h6>
                      </div>
                      <div className="col-3">
                        {x.evento_seguridad && (
                          <>
                            <p
                              style={{
                                fontSize: "12px",
                                fontWeight: "bold",
                                color: "red",
                                margin: "revert",
                                textAlign: "right",
                              }}
                            >
                              {
                                x.registro_seguridad.evento
                              }
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}

          {results.length === 0 ? (
            <>
              <div className="row justify-content-center">
                <div className="col-4 mt-4" style={{ textAlign: "center" }}>
                  <h3>¡Búsqueda sin resultados! </h3>
                  <h4>¿desea agregar la unidad?</h4>
                </div>
                <div className="col-12 mt-4">
                  <SinUnidadAdd
                    tipo_unidad_id={tipoUnidades}
                    onAction={handleAction}
                    busqueda={search}
                  />
                </div>
              </div>
            </>
          ) : (
            <div className="position-relative">
              <Paginacion paginado={paginado} onPageChange={handlePageChange} />
            </div>
          )}
        </div>
      </div>

      {actiModal ? (
        <RegistrarEditarEventoRobo
          idUnidad={idUnidad}
          mostrarModal={actiModal}
          onAction={modalClose}
          tipo_unidad_id={tipoUnidades}
          eventAction={event}
          viajeId={viajeId}
        />
      ) : (
        ""
      )}
    </>
  );
};
